// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__SQlEM","title":"ClientInsurance_title__J5VMA","itemText":"ClientInsurance_itemText__2cdAF"};